/**
 * Authentication service using Scalekit OAuth 2.0 flow
 * Frontend is unaware of login implementation - uses /api/auth/me
 */
import { apiService } from './api';
import type { User } from '../types';

class AuthService {
  /**
   * Get authorization URL from backend and redirect
   * Frontend is unaware of login implementation - just calls backend
   */
  async redirectToLogin(organizationId?: string): Promise<void> {
    try {
      // Call backend to get authorization URL - backend handles redirect
      const url = `${import.meta.env.VITE_API_BASE_URL}/api/auth/authorize${organizationId ? `?organization_id=${organizationId}` : ''}`;
      window.location.href = url;
    } catch (error) {
      console.error('Error redirecting to login:', error);
      throw error;
    }
  }

  /**
   * Get current user (session handled via cookies)
   */
  async getMe(): Promise<User | null> {
    return await apiService.getMe();
  }

  /**
   * Logout - clear all stored data and call backend
   */
  async logout(): Promise<void> {
    try {
      // Call backend logout endpoint
      await apiService.logout();
    } catch (error) {
      console.error('Error calling logout endpoint:', error);
    }
  }
}

export const authService = new AuthService();
